import type { RoleConfig } from '../types.js';

export const lawyer: RoleConfig = {
  id: 'lawyer',
  faction: 'town',
  title: { ru: 'Адвокат', uk: 'Адвокат' },
  latin: 'LAWYER',
  number: '05',
  accent: '#6166ff',
  sub: '#8b8fb8',
  ability: {
    ru: 'Раз за игру отменяет голосование против выбранного игрока.',
    uk: 'Раз за гру скасовує голосування проти обраного гравця.',
  },
  abilities: [
    {
      key: 'shield',
      phase: 'day',
      cadence: 'one-time',
      canSelfTarget: false,
    },
  ],
  victory: { type: 'town' },
};
